import apiRequestType from "../apiRequestType";
import { apiConstants } from "../../utils/apiConstants";
import { apiTypes } from "../../utils/apiTypes";

const addGroupTopic = (data) => {
  return apiRequestType(
    apiTypes.POST,
    apiConstants.ORGANIZE.ADD_GROUP_TOPIC,
    data
  );
};

export default addGroupTopic;
